module.exports = __webpack_public_path__ + "img/40.cdf80729.jpg";